import { render, staticRenderFns } from "./CentralizedIssuesDataView.vue?vue&type=template&id=3d51eed8&scoped=true"
import script from "./CentralizedIssuesDataView.vue?vue&type=script&lang=js"
export * from "./CentralizedIssuesDataView.vue?vue&type=script&lang=js"
import style0 from "./CentralizedIssuesDataView.vue?vue&type=style&index=0&id=3d51eed8&prod&lang=scss&scoped=true"
import style1 from "./CentralizedIssuesDataView.vue?vue&type=style&index=1&id=3d51eed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d51eed8",
  null
  
)

export default component.exports